import React from "react";
import fb from '../../lib/firebase';
import FieldView from "../../components/FieldView";
import FormEvento from "./FormEventoHOC";
import {formDef} from "./FormEventoHOC";
import {
  EventoObject,
  eventoRequerProdutosUtilizados, eventoRequerProdutosVendidos,
  getProximoContatoLabel
} from "../../models/Evento";
import EntityView from "../../components/EntityView";
import {IonProgressBar, IonSkeletonText} from "@ionic/react";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import {dataInCurrentMonth, formatNumber, getCollectionFromRef} from "../../lib/utils";
import ProdutoVendidoItem from "../../components/ProdutoVendido/ProdutoVendidoItem";
import {mergeProdutosVendidos} from "../../models/Produto";
import {getPrincipalLabel, Principal} from "../../models/Principal";

interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: EventoObject;
  goBack: () => void;
  loading: boolean;
}

interface State {
  allowDelete: boolean;
  produtoVendidoLoja: string;
  principal?: Principal;
  principalIsLoading: boolean;
  totalVendidos: number | undefined;
}

class AbaEvento extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      allowDelete: false,
      produtoVendidoLoja: '',
      principal: undefined,
      principalIsLoading: false,
      totalVendidos: undefined,
    }
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.instance.id !== this.props.instance.id || prevProps.instance.atualizado_em !== this.props.instance.atualizado_em)
      this.updateState();
  }

  updateState = () => {
    this.setState({allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate())});

    const {instance} = this.props;
    // load ref loja
    if (eventoRequerProdutosVendidos(getCollectionFromRef(instance.principal.path), instance.tipo, instance.descricao)) {
      const {produtos_vendidos_loja} = instance;
      if (produtos_vendidos_loja) {
        produtos_vendidos_loja.get().then(snap => {
          const loja = fb.doc(snap);
          let produtoVendidoLoja;
          if (!loja)
            produtoVendidoLoja = '--nao encontrado--';
          else
            produtoVendidoLoja = loja.nome;
          this.setState({produtoVendidoLoja});
        })
      }
    }

    // update total vendidos
    if (instance.produtos_vendidos && instance.produtos_vendidos.length) {
      let total = 0;
      instance.produtos_vendidos.forEach(i => {
        total += i.quantidade * i.valor!;
      });
      this.setState({totalVendidos: total});
    }

    // load principal
    if (instance) {
      this.setState({principalIsLoading: true, principal: undefined}, () => {
        instance.principal.path.get()
          .then(snap => {
            this.setState({principal: fb.doc(snap), principalIsLoading: false});
          })
          .catch(error => {
            this.props.dispatch(actions.notifyError(error));
            this.setState({principalIsLoading: false});
          })
      });
    }
  }

  onDelete = () => {
    fb.db.collection('eventos').doc(this.props.instance.id).delete()
      .then(() => {
        this.props.dispatch(actions.notifySuccess('Evento excluído com sucesso.'));
        this.props.goBack();
      });
  };

  render() {
    const {instance} = this.props;
    const collection = getCollectionFromRef(instance.principal.path);

    if (this.props.loading)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <EntityView
        instance={instance}
        ModelForm={FormEvento}
        entityLabel="Evento"
        gender="m"
        onDelete={this.onDelete}
        allowDelete={this.state.allowDelete}
        allowEdit={this.state.allowDelete}
      >
        <div className="flex">
          <div className="w-1/2">
            <FieldView label={formDef.data.label} type="date"
                       value={instance.data} className="text-xl"/>
          </div>
          <div className="w-1/2">
            <FieldView label={formDef.tipo.label}
                       value={instance.tipo} className="text-xl"/>
          </div>
        </div>

        {this.state.principalIsLoading &&
          <IonProgressBar type="indeterminate"/>
        }
        {this.state.principal &&
          <FieldView
            label="Referente a"
            value={`${getPrincipalLabel(this.state.principal.type)}: ${this.state.principal.nome}`}
          />
        }
        <FieldView label={formDef.descricao.label} value={instance.descricao}
                   className="font-bold"/>

        {collection === 'fazendas' && eventoRequerProdutosUtilizados(collection, instance.tipo, instance.descricao) &&
          <FieldView
            label="Produtos utilizados"
            value={instance.produtos_utilizados ? instance.produtos_utilizados.map(i => i.label).join(', ') : ''}
          />
        }

        {collection === 'fazendas' &&
          eventoRequerProdutosVendidos(collection, instance.tipo, instance.descricao) &&
          instance.produtos_vendidos?.length &&
          <>
            <div className="app-modelview-section-title">
              Produtos vendidos
            </div>
            <div>
              <div className="flex flex-col gap-2 w-full 2xl:w-8/12">
                {instance.produtos_vendidos && mergeProdutosVendidos(this.props.app.cacheData.produtos, instance.produtos_vendidos).map(produto => (
                  <ProdutoVendidoItem
                    key={produto.sku}
                    produto={produto}
                  />
                ))}
                <div className="flex gap-2 text-xs w-full items-center">
                  <div className="font-bold w-2/12">
                    Total:
                  </div>
                  <div className='flex items-baseline w-10/12'>
                    <div className="text-right w-10/12 font-bold">
                      R$ {formatNumber(this.state.totalVendidos)}
                    </div>
                    <div className='w-2/12'></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <FieldView
                label="Produtos vendidos loja"
                value={this.state.produtoVendidoLoja || <IonSkeletonText animated/>}
              />
            </div>
          </>
        }

        <FieldView label={formDef.notas.label} type="text" value={instance.notas}
                   className="text-gray-600"/>

        {instance.proximo_contato &&
          <FieldView
            label={getProximoContatoLabel(collection, instance.tipo, instance.descricao, 'proximo_contato')}
            type="date"
            value={instance.proximo_contato}
          />
        }
        {instance.proximo_contato_notas &&
          <FieldView
            def={formDef.proximo_contato_notas}
            label={getProximoContatoLabel(collection, instance.tipo, instance.descricao, 'proximo_contato_notas')}
            value={instance.proximo_contato_notas}
          />
        }
      </EntityView>
    )
  }
}

export default connect(({app}: RootState) => ({app}))(AbaEvento);